import { useEffect } from 'react';
import { useAuth } from 'utils/AuthContext';
import { startActiveShiftMonitor, stopActiveShiftMonitor } from 'utils/activeShiftMonitor';

/**
 * ActiveShiftMonitor Component
 * 
 * This component starts the background monitoring for active shifts
 * when a user is logged in. It checks hourly for shifts that are
 * 3+ hours past their scheduled end time and sends notifications.
 * 
 * Only runs when users are logged in to avoid unnecessary checks.
 */
export const ActiveShiftMonitor: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Only start monitor if user is logged in
    if (user) {
      startActiveShiftMonitor();

      // Cleanup: stop monitor when component unmounts or user logs out
      return () => {
        stopActiveShiftMonitor();
      };
    }
  }, [user]);

  // This component doesn't render anything
  return null;
};
